import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusIcon } from 'lucide-react';
import { useLocale } from '../contexts/LocaleContext';

/**
 * Contextual "+" for social surfaces (Community, Community detail).
 * Opens the Create menu, where Pulse is always free and Post follows the gate.
 * Deliberately modest: 48px, never an oversized floating button.
 */
export function CreateFab() {
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  return <div className="pointer-events-none sticky bottom-3 z-30 mt-2 flex justify-end px-2" data-id="element-574" data-mp="1bj9hg93fjq0d">
      <button type="button" onClick={() => navigate('/novo')} aria-label={t('community.create')} className="pointer-events-auto grid h-12 w-12 place-items-center rounded-pill border border-gold/55 bg-deep text-gold shadow-lift transition-transform duration-150 ease-brand active:scale-[0.96]" data-id="element-575" data-mp="1fkctslm9r3wu">
        <PlusIcon size={22} data-id="element-576" data-mp="3r7j7ciyu4l5e" />
      </button>
    </div>;
}